<template>
	<v-card flat rounded="0">
		<v-card-title primary-title>
			<v-row dense justify="space-between">
				<v-col cols="12" sm="8">
					<div
						v-if="$vuetify.breakpoint.mdAndDown"
						:class="`primary--text text-overline ml-2 ${
							$vuetify.breakpoint.xs ? 'text-center' : ''
						}`"
					>
						Ofertas
					</div>
					<div
						v-else
						class="font-weight-light primary--text text-h4 ml-2 text-capitalize"
					>
						Ofertas
					</div>
				</v-col>
				<v-col
					sm="4"
					cols="12"
					:class="`d-flex align-center ${
						$vuetify.breakpoint.xs
							? 'justify-center'
							: 'justify-end'
					}`"
				>
				</v-col>
			</v-row>
		</v-card-title>
		<!-- <v-divider class="test"></v-divider> -->
		<v-card-text class="d-flex">
			<v-row>
				<v-col cols="12" md="9">
					<!-- <v-card> -->
						<v-data-table
							:headers="headers"
							:items="seguimientoOfertasOfertas"
						></v-data-table>
					<!-- </v-card> -->
				</v-col>
				<v-col cols="12" md="3">
					<!-- <v-card class="pa-4"> -->
						<BarChart
							:chart-data="barData"
							:options="optionsBarChart"
						></BarChart>
					<!-- </v-card> -->
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapState } from 'vuex';
import BarChart from '@/components/GerenciaTeletrabajo/Stats/BarChart.js';


export default {
	name: 'seguimientoOfertasOfertas',
	data: () => ({
		optionsBarChart: {
			scales: {
				yAxes: [
					{
						stacked: true,
					},
				],
				xAxes: [
					{
						stacked: true,
					},
				],
			},
			legend: {
				display: true,
				position: 'top',
				align: 'center',
				labels: {
					padding: 10,
				},
			},
			responsive: true,
			maintainAspectRatio: false,
		},
		headers: [
			{ text: 'Accesorios', value: 'Accesorios' },
			{ text: 'Seguros', value: 'Seguros' },
			{ text: 'Dispositivos', value: 'Dispositivos' },
			{ text: 'Terminales', value: 'Terminales' },
			{ text: 'Terminales_Captacion', value: 'Terminales_Captacion' },
			{ text: 'Terminales_Fide', value: 'Terminales_Fide' },
			{ text: 'cif', value: 'cif' },
			{ text: 'comercial', value: 'comercial' },
			{ text: 'distribuidor', value: 'distribuidor' },
			{ text: 'estado', value: 'estado' },
			// { text: 'idUsuario', value: 'idUsuario' },
			{ text: 'propuestas', value: 'propuestas' },
			{ text: 'sfid', value: 'sfid' },
		],
	}),
	components: {
		BarChart,
	},
	methods: {},
	computed: {
		barData(){
			let chartData = {}
			chartData.labels = []
			chartData.datasets = []

			chartData.datasets[0] = {
				type: 'bar',
				label: 'Accesorios',
				data: this.seguimientoOfertasOfertas.map((item) => Number(item.Accesorios)),
				backgroundColor: "grey",
				fill: true,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			chartData.datasets[1] = {
				type: 'bar',
				label: 'Seguros',
				data: this.seguimientoOfertasOfertas.map((item) => Number(item.Seguros)),
				backgroundColor: "blue",
				fill: true,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			chartData.datasets[2] = {
				type: 'bar',
				label: 'Dispositivos',
				data: this.seguimientoOfertasOfertas.map((item) => Number(item.Dispositivos)),
				backgroundColor: "red",
				fill: true,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			chartData.datasets[3] = {
				type: 'bar',
				label: 'Terminales',
				data: this.seguimientoOfertasOfertas.map((item) => Number(item.Terminales)),
				backgroundColor: "green",
				fill: false,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			chartData.datasets[4] = {
				type: 'bar',
				label: 'Terminales_Captacion',
				data: this.seguimientoOfertasOfertas.map((item) => Number(item.Terminales_Captacion)),
				backgroundColor: "orange",
				fill: false,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			chartData.datasets[5] = {
				type: 'bar',
				label: 'Terminales_Fide',
				data: this.seguimientoOfertasOfertas.map((item) => Number(item.Terminales_Fide)),
				backgroundColor: "orange",
				fill: false,
				categoryPercentage: 0.5,
				barPercentage: 1,
				_meta: {}
			}
			
			chartData.labels = this.seguimientoOfertasOfertas.map((item) => `${item.estado}: ${item.propuestas}`)
			return chartData
		},
		...mapState('retailX', {
			seguimientoOfertasOfertas: (state) =>
				state.seguimientoOfertasOfertas,
		}),
	},
	beforeCreate() {
		//this.$store.dispatch('retailX/fetchAll');
	},
};
</script>